import { Facility, IFacility } from "@/api";
import { useAppSelector } from "@/common/hooks";
import { KeyBy } from "@/common/types";

export const useFacilities = () => {
  return useAppSelector((state) => state.appConfig.facility.facilities);
};

export function useFacilityById(): KeyBy<Facility.DTO, "id">;
export function useFacilityById(facilityId: IFacility["id"] | undefined): Facility.DTO | undefined;
export function useFacilityById(
  facilityId?: IFacility["id"],
): Facility.DTO | KeyBy<Facility.DTO, "id"> | undefined {
  const facilitiesById = useAppSelector((state) => state.appConfig.facility.facilityById);

  if (arguments.length === 0) return facilitiesById;
  if (facilityId === undefined) return undefined;
  return facilitiesById[facilityId];
}
